import diners from '@/images/payment-methods/diners.svg';
import discover from '@/images/payment-methods/discover.svg';
import link from '@/images/payment-methods/link.svg';
import paypal from '@/images/payment-methods/paypal.svg';
import unionpay from '@/images/payment-methods/union.svg';
import amex from '@/images/payment-methods/card_amex.svg';
import visa from '@/images/payment-methods/card_visa.svg';
import jcb from '@/images/payment-methods/jcb-card.svg';
import mastercard from '@/images/payment-methods/card_master.svg';
import applePay from '@/images/payment-methods/applepay.svg';
import googlePay from '@/images/payment-methods/googlepay.svg';

export const paymentMethodLogos = {
	amex,
	applePay,
	diners,
	discover,
	googlePay,
	link,
	mastercard,
	mc: mastercard,
	paypal,
	unionpay,
	visa,
	visacredit: visa,
	jcb
};

export const walletLogos = {
	google_pay: googlePay,
	apple_pay: applePay
};
